import IOwInputProps from "../OwInput/IOwInputProps";
import { useIntl } from "react-intl";
import OwInput from "../OwInput/OwInput";
import React from "react";
import UIService from "../../../services/UIService";
import { UseFormRegisterReturn } from "react-hook-form";

type Props = IOwInputProps & {
    id?: string;
    className?: string;
    placeholder?: string;
    fn: any;
    onKeyDownFn?: (e: any) => void;
    onClickFn?: (e: any) => void;
    disabled?: boolean;
    value?: any;
    name: string;
    ref?: React.RefObject<any>;
    type?: "number" | "email" | "password" | "text" | "tel" | "radio";
    autoComplete?: boolean | string;
    isRequired?: boolean;
    minLength?: number;
    maxLength?: number;
    isSmall?: boolean;
    supplierModel?: any;
    isSupplierVendorOverride?: boolean;
    min?: number;
    max?: number;
    step?: number | "any";
    showStep?: boolean;
    tabIndex?: number;
    disableKeyUp?: boolean;
    editMode?: boolean;
    // @deprecated - Use OwCheckbox instead.
    checked?: boolean;
    returnZero?: boolean;
    title?: string;
    maskedInput?: boolean;
    mask?: string;
    maskChar?: string;
    defaultClassName?: string;
    alwaysShowMask?: boolean;
    enableDebounce?: boolean;
    disablePrecisionCheck?: boolean;
    autoFocus?: boolean;
    onWheelFn?: (e: any) => void;
    testId?: string;
    register?: UseFormRegisterReturn<any>;
};

const OwInputWrapper = (props: Props) => {
    const intl = useIntl();

    return <OwInput {...props} intl={intl} onWheelFn={props.type === "number" ? UIService.stopScrollWheel : props.onWheelFn} />;
};

export default OwInputWrapper;
